import React from "react";
import svg6 from "../../../../assets/svg/svg6.svg";
import svg7 from "../../../../assets/svg/svg7.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setActiveObj } from "../../../../features/obj/objSlice";

function ProjectDetails() {
  const navigate = useNavigate();
  const dispatch  =  useDispatch() 
  const { activeObjexpressions } = useSelector((state) => ({
    activeObjexpressions: state.obj.activeObj["expressions"],
  }));
    const handleEdit = async () => {
      await dispatch(setActiveObj({ key: "expressions", data: activeObjexpressions })); 
      await navigate("/expression-add");
    };
 
  return (
    <div className="mt-[1.25rem] white_card">
      <div className="form-add-h">{activeObjexpressions?.projectName}</div>
      <div className="mt-[.75rem] flex items-center gap-x-[.62rem]">
        <div className="flex items-center gap-x-1">
          <img src={svg6} alt="svg6" />
          <span className="forgot-text !text-[#393939]">
            {activeObjexpressions?.farmerName}
          </span>
        </div>

        <div className="flex items-center gap-x-1">
          <img src={svg7} alt="svg7" />
          <span className="forgot-text !text-[#393939]">
            {activeObjexpressions?.countyName}
          </span>
        </div>

        <div className="flex items-center gap-x-1">
          <img src={svg6} alt="svg6" />
          <span className="forgot-text !text-[#393939]">
            {activeObjexpressions?.schemeType}
          </span>
        </div>

        <div className="flex items-center">
          <span className={`forgot-text !text-[#393939] ${activeObjexpressions?.projectStatus === 'Published' ? 'bg-[#B1E17C]':'bg-[#E5E8E9]'}  rounded-[.5rem] w-auto justify-center flex items-center py-[.125rem] px-[.25rem]`}>
            {activeObjexpressions?.projectStatus}
          </span>
        </div>
      </div>
     
      <div className="mt-[1.25rem]  proj_desc lg:w-[30.6875rem] w-full">
        {activeObjexpressions?.projectDescription}
      </div>
    </div>
  );
}

export default ProjectDetails;
